import { useSelector } from "react-redux";
import ReusableRegularization from "./resuableRegularization";
import { useLazyGetPendingRegularizationQuery } from "../../api/regularizationApi";
import { useEffect } from "react";
import noDataRegularizationIcon from "../../Icons/noDataRegularizationIcon.svg";
import regularizationAdminDoneIcon from "../../Icons/regularizationAdminDoneIcon.svg";

const PendingRegularization = ({ shouldGetManagerRecords }) => {
  const { pendingRegularization } = useSelector(
    (state) => state.regularization
  );
  const [getPendingRegularization] = useLazyGetPendingRegularizationQuery();
  const { isReviewRegularizationScreen } = useSelector(
    (state) => state.regularization
  );
  useEffect(() => {
    const isEmployee = shouldGetManagerRecords;
    getPendingRegularization(isEmployee);
  }, []);

  return (
    <div className="w-[97%] mx-5">
      {pendingRegularization.length === 0 ? (
        <div className="flex flex-col gap-5 items-center justify-center text-center pt-10 h-[90%] w-full">
          <img
            alt="NoData"
            width="400px"
            src={
              isReviewRegularizationScreen
                ? regularizationAdminDoneIcon
                : noDataRegularizationIcon
            }
          />
          <p className="font-medium text-lg">
            {isReviewRegularizationScreen
              ? "Youre all caught up! No active regularization requests at the moment."
              : "All your requests have been reviewed. You can apply a new regularization if needed."}
          </p>
        </div>
      ) : (
        pendingRegularization.map((each) => (
          <ReusableRegularization
            key={each.id}
            data={each}
            shouldShowApplyRejectButtons={true}
          />
        ))
      )}
    </div>
  );
};

export default PendingRegularization;
